import { DefaultModal } from "@components/default-modal"
import { Center, InputWrapper, ModalProps, Stack } from "@mantine/core"
import { useTranslation } from "react-i18next"
import { DatePicker } from "@mantine/dates"

interface Props extends ModalProps {
  onSelectStartDate: (date: Date) => void
}

export function CalendarWeekListSettingsModal({
  onSelectStartDate,
  ...modalProps
}: Props) {
  const { t } = useTranslation("app_server")
  return (
    <DefaultModal
      title={t("CalendarWeekListSettingsModal_Title")}
      {...modalProps}
    >
      <Stack p={0}>
        <InputWrapper
          w={"100%"}
          label={t("CalendarWeekListSettingsModal_StartDate")}
        >
          <Center>
            <DatePicker
              onChange={(v) => {
                if (v) {
                  onSelectStartDate(new Date(v))
                  modalProps.onClose()
                }
              }}
            />
          </Center>
        </InputWrapper>
      </Stack>
    </DefaultModal>
  )
}
